export const HOUR = 60
export const DAY = HOUR * 24
export const NUMBER_OF_Y_AXIS_TICKS = 4
